import React from 'react';
import { Box } from '@mui/material';
import { BoxProps } from '@mui/system';
import { withStyles } from 'tss-react/mui';
import { themeColors } from '../../../theme';
import { LicenseHeight } from '../../Collections/CollectionsPanel/Media/License';
import { ContentCollectionType } from '../../../API';

type StyledLabelBadgeProps = BoxProps & {
  height?: number;
  label?: string;
  type?: string;
};

const backgroundByType: Record<string, string> = {
  [ContentCollectionType.EPISODE]: 'linear-gradient(to right, #02aab0, #00cdac)',
  [ContentCollectionType.CLIP]: 'linear-gradient(to right, rgb(0, 116, 72),rgb(2, 200, 118))',
  [ContentCollectionType.SHORT_CLIP]: 'linear-gradient(to right,rgb(95, 162, 13),rgb(56, 221, 2))'
};

export const StyledLabelBadge = withStyles(
  ({ label, type, ...rest }: StyledLabelBadgeProps) => {
    const background = (type && backgroundByType[type]) || themeColors.success;

    return (
      <Box
        {...rest}
        component="span"
        sx={{
          fontSize: '0.75rem',
          fontWeight: 'bold',
          lineHeight: 1,
          letterSpacing: '0.05em',
          px: 0.75,
          py: 0.25,
          borderRadius: 0.75,
          display: 'inline-flex',
          alignItems: 'center',
          background,
          color: '#fff'
        }}
      >
        {label}
      </Box>
    );
  },
  (theme, { height = LicenseHeight }: StyledLabelBadgeProps) => ({
    root: {
      display: 'flex',
      width: 'fit-content',
      height,
      padding: Math.round(height * 0.25),
      position: 'absolute',
      top: 0,
      right: 0,
      color: 'white',
      borderRadius: '0 0 0 12px',
      ['& > svg']: {
        height: '100%',
        ['& > g > path']: {
          fill: 'white'
        }
      }
    }
  })
);
